import { v4 as uuidv4 } from 'uuid';
import GetElementStringMixin from '@/mixins/get-element-string';
import {
  ORDER_PAYMENTS,
  DEFAULT_PHARMACIES,
  STATUS_CODES,
  STATUS_CODES_TEXT,
  CANCELLED_STATUSES,
} from '@/reference/medicine';
import {
  MSG_TYPES,
} from '@/constants/inbox-messages';
import ToastMixin from '@/mixins/toast-mixin';
import CDEventBusMixin from '@/mixins/content-dictionary-event-bus-mixin';
import {
  REGINE_NUMBER,
} from '@/reference/medicine';

export default {
  mixins: [
    GetElementStringMixin,
    CDEventBusMixin,
    ToastMixin,
  ],
  data() {
    const txt360$1Id = uuidv4();
    const txt360$2Id = uuidv4();
    const txt199$1Id = uuidv4();
    return {
      txt360$1Id,
      txt360$2Id,
      txt199$1Id,
      targetCDEvents: [
        {
          id: txt360$1Id,
          handler: this.paymentLinkHandler,
        },
        {
          id: txt360$2Id,
          handler: this.paymentLinkHandler,
        },
        {
          id: txt199$1Id,
          handler: this.paymentLinkHandler,
        },
      ],
    };
  },
  methods: {
    /**
     * 
     * i cant think of sensible method name for this rn
     * 
     * @param {String} message - can be string or json stringified string
     * 
     */
    getParsedOrderMessage(message, messageType) {
      try {
        const orderMessage = JSON.parse(message);

        if (messageType === MSG_TYPES.paymentdetails) {
          const {labelId, props} = this.getPaymentDetailsLabelProps(orderMessage);
          return this.getElementString(labelId, props);
        } else if (messageType === MSG_TYPES.orderstatus) {
          const {labelId, props} = this.getOrderStatusUpdateLabelProps(orderMessage);
          return this.getElementString(labelId, props);
        } else {
          return message;
        }
      } catch (error) {
        if (messageType === MSG_TYPES.file) {
          return message === '' ? 'You sent a file' : message;
        }

        return message;
      }
    },
    getPaymentDetailsLabelProps(orderMessage) {
      const isCod = orderMessage.paymenttype === ORDER_PAYMENTS.cod;

      if (orderMessage.partnercode === DEFAULT_PHARMACIES.ssd) {
        const props = {numbers: [orderMessage.amount]};

        return {
          labelId: isCod ? 'txt193' : 'txt248',
          props,
        };
      } else {
        if (isCod) {
          return {labelId: 'txt234', props: {numbers: [orderMessage.amount]}};
        } else {
          const props = {
            numbers: [orderMessage.amount],
            functions: {
              $1: this.getEventEmitId(this.txt199$1Id, {paymentlink: REGINE_NUMBER}),
            },
          };
          let labelId = 'txt199';

          if (orderMessage.paymentlink && orderMessage.paymentlink !== '') {
            props.strings = [orderMessage.paymentlink];
            props.functions = {
              $1: this.getEventEmitId(this.txt360$1Id, {paymentlink: orderMessage.paymentlink}),
              $2: this.getEventEmitId(this.txt360$2Id, {paymentlink: REGINE_NUMBER}),
            };
            labelId = 'txt360';
          }

          return {labelId, props};
        }
      }
    },
    getOrderStatusUpdateLabelProps(orderMessage) {
      let labelId = 'txt173';
      const props = {};

      if (CANCELLED_STATUSES.includes(orderMessage.orderstatus)) {
        labelId = 'txt243';
        props.strings = [STATUS_CODES_TEXT[orderMessage.orderstatus]];
      }

      switch (orderMessage.orderstatus) {
        case STATUS_CODES.DELIVERING:
          labelId = orderMessage.paymenttype === ORDER_PAYMENTS.cod ? 'txt235' : 'txt225';
          props.numbers = [orderMessage.amount];
          break;

        case STATUS_CODES.FULFILLED:
          labelId = 'txt226';
          break;

        case STATUS_CODES.PROC_FAILED_DELIVERY:
          labelId = 'txt246';
          break;
      }

      return {labelId, props};
    },
    paymentLinkHandler({paymentlink}) {
      console.log('paymentLinkHandler');
      if (paymentlink.includes('http')) {
        window.open(paymentlink, '_blank');
      } else {
        this.copyTextToClipboard(paymentlink);
      }
    },
    copyTextToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.showToast({
            text: `Copied ${text} to clipboard`,
            theme: 'success',
          });
        });
    },
  },
}
